module.exports = __webpack_public_path__ + "img/title-logo.10f6b57e.png";